<template>
  <EarTrainingGame :choices="choices">
    <SubTitle>Guess the interval</SubTitle>
    <p>
      Listen to the interval and try to guess it by ear.
    </p>
  </EarTrainingGame>
</template>

<script>
import EarTrainingGame from "./EarTrainingGame";

const SECONDS = [
  { name: "minor 2nd", notes: ["C4", "Db4"] },
  { name: "major 2nd", notes: ["C4", "D4"] }
];

const THIRDS = [
  { name: "minor 3rd", notes: ["C4", "Eb4"] },
  { name: "major 3rd", notes: ["C4", "E4"] }
];

const FOURTHS = [
  { name: "4th", notes: ["C4", "F4"] },
  { name: "augmented 4th", notes: ["C4", "F#4"] }
];

const FIFTHS = [{ name: "5th", notes: ["C4", "G4"] }];

const SIXTHS = [
  { name: "minor 6th", notes: ["C4", "Ab4"] },
  { name: "major 6th", notes: ["C4", "A4"] }
];

const SEVENTHS = [
  { name: "minor 7th", notes: ["C4", "Bb4"] },
  { name: "major 7th", notes: ["C4", "B4"] }
];

export default {
  name: "IntervalGame",
  components: { EarTrainingGame },
  data: () => ({
    choices: [
      ...SECONDS,
      ...THIRDS,
      ...FOURTHS,
      ...FIFTHS,
      ...SIXTHS,
      ...SEVENTHS
    ]
  })
};
</script>
